import * as React from 'react'
import styled, { css } from 'styled-components'

import MuiButton, { ButtonProps as MuiButtonProps } from '@material-ui/core/Button'
import CircularProgress                             from '@material-ui/core/CircularProgress'

interface ButtonProps extends MuiButtonProps {
  theme?: any,
  displayLoader?: boolean
  secondary?: boolean
}

const hoverbutton = ({theme, color, variant, secondary}) => {
  if(color == 'secondary'){
    return css`
    background-color: ${theme.ButtonBackgroundHoverSecondaryColor};
    color: ${theme.ButtonFontHoverSecondaryColor};
    text-transform: capitalize;
    `
  }else{
    if (secondary) {
      if (variant === 'raised') {
        return css`
          background-color: ${theme.ButtonBackgroundHoverColor};
          color: ${theme.ButtonFontHoverColor}
          text-transform: capitalize;
          `
      } else {
        return css`
          background-color: ${theme.ButtonNotRaisedBackgroundHoverColor};
          color: ${theme.ButtonNotRaisedFontHoverColor}
          text-transform: capitalize;
          `        
      }
    } else {
      if (color == 'primary'){
        if (variant == 'raised') {
          return css`
          background-color: ${theme.ButtonBackgroundHoverColor};
          color: ${theme.ButtonFontHoverColor};
          text-transform: capitalize;
          `
        } else {
          return css`
          background-color: ${theme.ButtonNotRaisedBackgroundHoverColor};
          color: ${theme.ButtonNotRaisedFontHoverColor};
          text-transform: capitalize;
          `                
        }
      }else{
        if (variant == 'raised') {
          return css`
          background-color: ${theme.ButtonBackgroundHoverColor};
          color: ${theme.ButtonFontHoverColor};
          text-transform: capitalize;
          `
        } else {
          return css`
          background-color: ${theme.ButtonNotRaisedBackgroundHoverColor};
          color: ${theme.ButtonNotRaisedFontHoverColor};
          text-transform: capitalize;
          `                
        }
      }
    }
  }
}

const ButtonStyled: any = styled(MuiButton)`
  border: solid 1px ${({ theme }) => theme.ButtonBorderColor};
  color: ${({ theme }) => theme.ButtonFontColor};
  background-color: ${({theme}) => theme.ButtonBackgroundColor};
  box-shadow: none;
  text-transform: capitalize;

  ${({theme, color}: ButtonProps) => (color === 'secondary' ) && css`
    background-color: ${theme.actionButtonBackgroundSecondaryColor};
    border: solid 1px ${theme.actionButtonBorderSecondaryColor};
    color: ${theme.actionButtonFontSecondaryColor};
    text-transform: capitalize;
  `}

  ${({theme, secondary, variant}: ButtonProps) => (secondary && variant === 'raised') && css`
    background-color: ${theme.ButtonBackgroundColor};
    border: solid 1px ${theme.ButtonBorderColor};
    color: ${theme.ButtonFontColor};
    text-transform: capitalize;
  `}

  ${({theme, secondary, variant}: ButtonProps) => (secondary && variant === undefined) && css`
  background-color: ${theme.ButtonNotRaisedBackgroundColor};
  border: ${theme.ButtonNotRaisedBorderColor}; 
  color: ${theme.ButtonNotRaisedFontColor};
  text-transform: capitalize;
`}


  ${({theme, color,variant}: ButtonProps) => (color === 'primary' && variant === undefined) && css`
  background-color: ${theme.ButtonNotRaisedBackgroundColor};
  border:${theme.ButtonNotRaisedBorderColor}; 
  color: ${theme.ButtonNotRaisedFontColor};
  text-transform: capitalize;
`}
${({theme, color,variant}: ButtonProps) => (color === 'primary' && variant === 'raised') && css`
background-color: '${theme.ButtonBackgroundColor}';
border: solid 1px ${theme.ButtonBorderColor};
color: ${theme.ButtonFontColor};
text-transform: capitalize;
`}

${({theme, color, variant}: ButtonProps) => (color === 'secondary' && variant === 'raised') && css`
background-color: ${theme.ButtonBackgroundColor};
border: solid 1px ${theme.ButtonBorderColor};
color: ${theme.ButtonFontColor};
text-transform: capitalize;
`}

  &:hover {
    ${hoverbutton}
  }
`

const Button: React.SFC<ButtonProps> = ({ displayLoader, children, ...rest }) => {
  const content = displayLoader
    ? <CircularProgress size={20} />
    : children

  return (
    <ButtonStyled {...rest}>
      {content}
    </ButtonStyled>
  )
}

export default Button



// WEBPACK FOOTER //
// ./src/components/atoms/Button.tsx